import React from 'react';

export const GlowingCard = ({ children, className = '', hoverGlow = true }) => {
  return (
    <div className={`relative group ${className}`}>
      {hoverGlow && (
        <div className="absolute -inset-0.5 bg-gradient-to-r from-amber-500 via-cyan-500 to-amber-500 rounded-none opacity-0 group-hover:opacity-75 blur-md transition-opacity duration-500" />
      )}
      <div className="relative bg-slate-900 border border-slate-800 group-hover:border-amber-500/50 transition-all duration-500">
        {children}
      </div>
    </div>
  );
};

export default GlowingCard;
